<template>
    <div>
        <div class="webMonitor-title">
            <div>{{$t('alarms.network.AppService.title')}}</div>
            <div>
                <Button type="primary" @click="addOrUpdateHandle" v-hasPermission="['network:webMonitor:add_alert_rule']">{{$t('alarms.network.AppService.addAppServiceAlertRule')}}</Button>
                <add-or-update-web-warning v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-web-warning>
            </div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.network.AppService.title')">
                    <div class="webMonitor-top">
                        <web-monitor-search></web-monitor-search>
                    </div>
                    <table-web></table-web>
                </TabPane>
            </Tabs>
        </template>
    </div>
</template>

<script>
    import WebMonitorSearch from '../web/WebMonitorSearch'
    import TableWeb from '../web/TableWeb'
    import AddOrUpdateWebWarning from '../web/AddOrUpdateWebWarning'

    export default {
        name: 'WebMonitor',
        components: {
            WebMonitorSearch,
            TableWeb,
            AddOrUpdateWebWarning
        },
        data(){
            return {
                addOrUpdateVisible:false
            }
        },
         methods:{
            // 添加报警规则
            /**********************************************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init()
                })
            }
        }
    }
</script>

<style scoped>
    .webMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .webMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .webMonitor-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .webMonitor-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/web/WebMonitor.vue